<div class="card harp-reg-card harp-material">
  <div class="card-body">
    <h2 class="account-info harp-card-title">Account Information</h2>

    <!-- Error Message -->
    <div class="row" *ngIf="errorMessage">
      <div class="col-12">
        <div class="alert alert-danger" role="alert" [innerHTML]="errorMessage">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div *ngIf="!errorMessage || errorCode">
      <p>
        Create your user ID, password, and challenge question.
        <br />
        All fields marked with an asterisk (<span class="required">*</span>) are
        required.
      </p>

      <form [formGroup]="accountInfoForm">
        <!-- User ID Input -->
        <div class="row" *ngIf="!isLoa3Flow">
          <div class="col-md-6">
            <harp-input
              [maskData]="true"
              [inputConfig]="userIdInputConfig"
            ></harp-input>
          </div>
        </div>

        <div class="row" *ngIf="!isLoa3Flow">
          <!-- Password Input -->
          <div class="col-md-6">
            <harp-input
              [maskData]="true"
              [inputConfig]="passwordInputConfig"
            ></harp-input>
          </div>

          <!-- Confirm Password Input -->
          <div class="col-md-6">
            <harp-input
              [maskData]="true"
              [inputConfig]="confirmPasswordInputConfig"
            ></harp-input>
          </div>

          <!-- Password Strength Widget -->
          <div class="col-12 mt-2">
            <harp-password-strength
              [maskData]="true"
              [passwordToCheck]="password"
            ></harp-password-strength>
          </div>
        </div>

        <div class="row">
          <!-- Challenge Question Input -->
          <div class="col-md-6">
            <harp-input
              [maskData]="true"
              [inputConfig]="challengeQuestionInputConfig"
            ></harp-input>
          </div>

          <!-- Challenge Question Answer Input -->
          <div class="col-md-6">
            <harp-input
              [maskData]="true"
              [inputConfig]="challengeQuestionAnswerInputConfig"
            ></harp-input>
          </div>

          <!-- Challenge Question Answer Help Text -->
          <div class="col-12">
            <p class="harp-help-text">
              Challenge Answer must be at least 4 characters and cannot contain
              the challenge question, user ID, or password.
            </p>
          </div>
        </div>

        <div *ngIf="captchaConfig$ | async as captchaConfig; else loading">
          <re-captcha
            *ngIf="showRecaptcha"
            name="captcha"
            [required]="showRecaptcha"
            theme="light"
            formControlName="recaptcha"
            [siteKey]="captchaConfig.reCaptchaSiteKey"
          ></re-captcha>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="row">
  <!-- Back Button -->
  <div class="col-md-3 offset-md-6">
    <button
      class="btn btn-outline-primary btn-lg d-block w-100 harp-button-margin"
      [routerLink]="['/profile-info']"
      (click)="onBack()"
    >
      <em class="icon ion-md-arrow-round-back"></em> Back
    </button>
  </div>

  <!-- Next Button -->
  <div class="col-md-3">
    <button
      id="account-next-btn"
      class="btn btn-primary btn-lg d-block w-100 harp-button-margin"
      type="submit"
      (click)="isLoa3Flow ? proofUser() : performUserIDUniquenessCheck()"
      [disabled]="accountInfoForm.invalid || errorMessage || !isHdimLoaded"
    >
      Next <em class="icon ion-md-arrow-round-forward"></em>
    </button>
  </div>
</div>
